<template>
  <ReactSiteFrame :src="src" />
</template>

<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'ConfigurationReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: '/view/configuration'
    }
  }
}
</script>
